const actions = {
    FETCH_CT_SCHEDULE_LIST: 'FETCH_CT_SCHEDULE_LIST',
    FETCH_CT_SCHEDULE: 'FETCH_CT_SCHEDULE',
    RESET_CT_SCHEDULE_FORM: 'RESET_CT_SCHEDULE_FORM',

    // Action for fetching the paginated list/filtered results
    fetchCTScheduleListAction: (data) => {
        return {
            type: actions.FETCH_CT_SCHEDULE_LIST,
            data: data
        };
    },

    // Action for resetting the form (useful when closing a modal or clearing state)
    resetCTScheduleFormAction: () => {
        return {
            type: actions.RESET_CT_SCHEDULE_FORM,
            data: null
        };
    },

    // Action for fetching a single CT details (useful for editing)
    fetchCTScheduleAction: (data) => {
        return {
            type: actions.FETCH_CT_SCHEDULE,
            data: data
        };
    },
};

export default actions;